module.exports = __webpack_public_path__ + "static/img/xzbj_mzjg_icon.png";